import React, { Fragment } from 'react';
import { OnChange } from 'types/OnChange';
import DateSelector from './DateSelector';

type Props = {
  onChangeStartMonth: OnChange;
  onChangeEndMonth: OnChange;
  onChangeStartYear: OnChange;
  onChangeEndYear: OnChange;
  startMonth: { value: number; label: string };
  endMonth: { value: number; label: string };
  startYear: { value: number; label: string };
  endYear: { value: number; label: string };
  errorMessage?: string;
};

const DateRangeSelector: React.FC<Props> = ({
  onChangeStartMonth,
  onChangeEndMonth,
  onChangeStartYear,
  onChangeEndYear,
  startMonth,
  endMonth,
  startYear,
  endYear,
  errorMessage,
}: Props) => (
  <Fragment>
    <div className="row">
      <div className="col" style={{ maxWidth: 300 }}>
        <DateSelector
          onChangeMonth={onChangeStartMonth}
          onChangeYear={onChangeStartYear}
          month={startMonth}
          year={startYear}
          label="Start date"
        />
      </div>
      <div className="col" style={{ maxWidth: 300 }}>
        <DateSelector
          onChangeMonth={onChangeEndMonth}
          onChangeYear={onChangeEndYear}
          month={endMonth}
          year={endYear}
          label="End date"
        />
      </div>
    </div>
    <small>
      <span className={'date-range-error'} style={{ color: 'red' }}>
        {errorMessage}
        <br />
      </span>
    </small>
  </Fragment>
);

export default DateRangeSelector;
